<template>
  <div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <b-spinner
          label="Spinning"
          v-if="userHasPerms(['Clock in/out']) && fetchingClockings"
        ></b-spinner>

        <div class="card h-100 box-shadow mb-3 p-3">
          <div
            class="row"
            v-if="userHasPerms(['Clock in/out']) && !fetchingClockings"
          >
            <div class="col">
              <span v-if="daily_clockings.length == 0">
                <i class="lni lni-alarm-clock"></i> No clockings today</span
              >
              <span v-if="daily_clockings.length > 0" class="font-size-19">
                <i class="lni lni-alarm-clock"></i>
                <strong>
                  {{ daily_clockings[daily_clockings.length - 1].direction }}
                </strong>
                @
                {{
                  moment(
                    new Date(
                      daily_clockings[daily_clockings.length - 1].created_at
                    )
                  ).format("HH:mm:ss")
                }}
              </span>

              <span
                v-if="
                  daily_clockings.length > 0 &&
                  daily_clockings[daily_clockings.length - 1].rep_moveable
                "
                class="font-size-13 text-muted l-h-1"
              >
                <br />
                {{
                  daily_clockings[daily_clockings.length - 1].rep_moveable
                    .location
                }}
              </span>
            </div>
          </div>

          <div
            class="row"
            v-if="userHasPerms(['Clock in/out']) && !fetchingClockings"
          >
            <div class="col-6">
              <button @click="clockIn" class="btn btn-success mt-3 btn-block">
                <strong> IN </strong> <i class="lni lni-arrow-down-circle"></i>
              </button>
            </div>
            <div class="col-6">
              <button @click="clockOut" class="btn btn-warning btn-block mt-3">
                <strong> OUT </strong> <i class="lni lni-arrow-up-circle"></i>
              </button>
            </div>
          </div>

          <div class="row" :class="{ 'mt-5': userHasPerms(['Clock in/out']) }">
            <div class="col">
              <h3>Promotions</h3>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr
                      class="
                        bg-light
                        font-weight-bold font-size-11
                        text-uppercase
                      "
                    >
                      <td>Code</td>
                      <td>Name</td>
                      <td class="text-right">Min (Mandate)</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in promotions" :key="item.id">
                      <td>
                        {{ item.code }}
                      </td>
                      <td>
                        {{ item.name }}
                      </td>
                      <td class="text-right">
                        {{ item.mandate_pricing_min }}
                      </td>
                      <td class="text-right">
                        <span
                          class="pointer bg-light p-1"
                          @click="
                            selectedProduct = item;
                            showSelectedProduct = true;
                          "
                        >
                          <i
                            class="lni lni-keyword-research text-primary m-0"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="card box-shadow h-100">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h1 class="text-primary font-weight-bold text-monospace">
                  {{ branches }}
                </h1>
              </div>
              <div class="col-auto">
                <div class="circle-icon-con bg-primary">
                  <div class="circle-icon">
                    <i class="lni lni-apartment text-white font-size-26"></i>
                  </div>
                </div>
              </div>
            </div>

            <p class="font-weight-bold">Branches</p>

            <hr />

            <div class="row">
              <div class="col">
                <h1 class="text-primary font-weight-bold text-monospace">
                  {{ products }}
                </h1>
              </div>
              <div class="col-auto">
                <div class="circle-icon-con bg-primary">
                  <div class="circle-icon">
                    <i class="lni lni-package text-white font-size-26"></i>
                  </div>
                </div>
              </div>
            </div>

            <p class="font-weight-bold">Active Products</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="userHasPerms(['View reports'])">
      <div class="col-12 mt-3">
        <div class="row">
          <div class="col-md-8">
            <h3 class="m-0">Statistics</h3>
            <small class="text-muted">Past {{ reportDays }} day totals</small>
          </div>
          <div class="col-md-4">
            <select
              class="form-control"
              v-model="reportDays"
              @change="reportDaysSelect($event)"
            >
              <option value="7">7 Days</option>
              <option value="1">1 Days</option>
              <option value="14">14 Days</option>
              <option value="21">21 Days</option>
              <option value="28">28 Days</option>
              <option value="56">56 Days</option>
              <option value="84">84 Days</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12 my-3">
        <div class="card">
          <div class="card-body">
            <horizontal-bar-chart
              v-if="chartReady"
              :chart-data="chartData"
              :options="chartOptions"
            ></horizontal-bar-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5" v-if="userHasPerms(['View reports'])">
      <div class="col-md-6 my-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title border-0">Best Sellers</h5>
            <table class="table">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td></td>
                  <td>Name</td>
                  <td class="text-right">Units</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in top_sellers" :key="item.id">
                  <td>
                    <v-lazy-image
                      v-if="item.product.image"
                      :src="item.product.image"
                      style="height: 32px; width: 32px"
                    />
                  </td>
                  <td class="l-h-1">
                    <strong>{{ item.product.code }}</strong
                    ><br />
                    {{ item.product.name }}
                  </td>
                  <td class="text-right">{{ item.total_sold }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6 my-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title border-0">Slow Sellers</h5>
            <table class="table">
              <thead>
                <tr
                  class="bg-light font-weight-bold font-size-11 text-uppercase"
                >
                  <td></td>
                  <td>Name</td>
                  <td class="text-right">Units</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in worst_sellers" :key="item.id">
                  <td>
                    <v-lazy-image
                      v-if="item.product.image"
                      :src="item.product.image"
                      style="height: 32px; width: 32px"
                    />
                  </td>
                  <td class="l-h-1">
                    <strong>{{ item.product.code }}</strong
                    ><br />
                    {{ item.product.name }}
                  </td>
                  <td class="text-right">{{ item.total_sold }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12 my-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title border-0">Branch Sales</h5>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr
                    class="
                      bg-light
                      font-weight-bold font-size-11
                      text-uppercase
                    "
                  >
                    <td>Code</td>
                    <td>Name</td>
                    <td class="text-right">Orders</td>
                    <td class="text-right">Units</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in branch_orders" :key="item.id">
                    <td>
                      {{ item.branch.code }}
                    </td>
                    <td>{{ item.branch.name }}</td>
                    <td class="text-right">{{ item.total_orders }}</td>
                    <td class="text-right">{{ item.sum_total_quantity }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 my-3">
        <div class="card">
          <div class="card-body">
            <line-chart
              v-if="chartReady2"
              :chart-data="chartData2"
              :options="chartOptions2"
            ></line-chart>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :hide-footer="true"
      :title="selectedProduct ? selectedProduct.name : ''"
      size="lg"
      v-model="showSelectedProduct"
      :lazy="true"
    >
      <b-row v-if="selectedProduct">
        <b-col>
          

          <b-tabs class="mt-3">
            <b-tab title="Details">
              <div class="row">
            <div class="col-12 mt-3">
              <div class="border w-50 p-2 float-left">
                <small class="text-muted">MIN (Mandate)</small>
                <h4 class="font-weight-bold">
                  {{ selectedProduct.mandate_pricing_min | currency }}
                </h4>
              </div>
              <div
                class="border w-50 p-2 float-left"
                v-show="selectedProduct.mandate_pricing_max"
              >
                <small class="text-muted">MAX (List Price)</small>
                <h4 class="font-weight-bold">
                  {{ selectedProduct.mandate_pricing_max | currency }}
                </h4>
              </div>
            </div>
            <div class="col-12 my-3">
              <img
                v-if="selectedProduct.image"
                :src="selectedProduct.image"
                class="img-fluid mb-2"
              />
            </div>
          </div>
              <table class="table table-sm mt-2">
                <table-row
                  label="Description"
                  v-if="selectedProduct.description"
                  >{{ selectedProduct.description }}</table-row
                >

                <table-row label="Group"
                  >{{ selectedProduct.product_group.name }}
                </table-row>

                <table-row label="Supplier"
                  >{{ selectedProduct.supplier.name }}
                </table-row>

                <table-row label="Brand"
                  >{{ selectedProduct.brand.name }}
                </table-row>
              </table>
            </b-tab>
            <b-tab title="Comments">
              <div class="row my-3">
                <div class="col-12">
                  <div class="border">
                    <div v-if="loading">
                      <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Large Spinner"
                      ></b-spinner>
                    </div>

                    <div
                      v-for="comment in selectedProduct.product_comments"
                      :key="comment.id"
                      class="card border-bottom p-2 mb-1"
                    >
                      <p class="nl2br">
                        {{ comment.comment }}
                      </p>

                      <a
                        v-if="comment.file_url"
                        :href="comment.file_url"
                        target="new"
                      >
                        {{ comment.file_description }}<br />
                      </a>

                      <img
                        v-if="comment.image"
                        :src="comment.image"
                        class="img-fluid maxWidth500 my-2"
                      />

                      <div class="row">
                        <div class="col-auto">
                          <b-avatar v-if="!comment.user.image"></b-avatar>
                          <b-avatar
                            v-if="comment.user.image"
                            :src="comment.user.image"
                          ></b-avatar>
                        </div>
                        <div class="col">
                          <h6 class="mb-0 mt-1 font-weight-bold">
                            {{ comment.user.name }}
                          </h6>
                          <small class="text-muted">
                            <i class="lni lni-calendar"></i>
                            {{
                              moment(new Date(comment.created_at)).format(
                                "DD MMM YYYY, HH:mm:ss"
                              )
                            }}

                            |

                            {{
                              moment
                                .duration(
                                  moment(Date.now()).diff(
                                    moment(new Date(comment.created_at)),
                                    "seconds"
                                  ),
                                  "seconds"
                                )
                                .format("Y [year] D [day], H [hour &] m [min]")
                            }}
                            ago
                          </small>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import homeRepo from "@/api/repos/homeRepo";
import clockingRepo from "@/api/repos/clockingRepo";
import HorizontalBarChart from "../../components/charts/horizontalBar";
import LineChart from "../../components/charts/line";
import tableRow from "./../../components/common/TableRow.vue";

export default {
  components: {
    HorizontalBarChart,
    LineChart,
    tableRow,
  },
  data() {
    return {
      daily_clockings: [],
      fetchingClockings: true,
      company_id: localStorage.getItem("current_company_id"),
      notifications: [],
      products: 0,
      reportDays: 7,
      branches: 0,
      chartReady: false,
      top_sellers: [],
      branch_orders: [],
      worst_sellers: [],
      daily_orders: [],
      promotions: [],
      selectedProduct: null,
      showSelectedProduct: false,
      loading:false,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
      chartReady2: false,
      chartData2: {
        labels: [],
        datasets: [],
      },
      chartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
    };
  },

  mounted() {
    this.getData();

    if (this.userHasPerms(["View reports"])) {
      this.getStatistics(this.reportDays);
    }

    // redirect if location not available
    if (!("geolocation" in navigator)) {
      this.$router.push({ path: "no-location" });
    }

    navigator.geolocation.getCurrentPosition(
      () => {},
      () => {
        this.$router.push({ path: "no-location" });
      }
    );

    if (this.userHasPerms(["Clock in/out"])) {
      this.getDailyClockings();
    }
  },

  methods: {
    notificationVariant(level) {
      if (level == 1) {
        return "success";
      } else if (level == 2) {
        return "info";
      } else if (level == 3) {
        return "warning";
      } else {
        return "danger";
      }
    },

    reportDaysSelect(event) {
      this.reportDays = event.target.value;
      this.getStatistics(this.reportDays);
    },

    async getData() {
      try {
        let { data } = await homeRepo.home();
        this.notifications = data.notifications;
        this.products = data.products;
        this.branches = data.branches;
        this.promotions = data.promotions;
      } catch (e) {
        if (this.timer) clearInterval(this.timer);
      }
    },

    async getStatistics(reportDays) {
      try {
        let { data } = await homeRepo.statistics(reportDays);

        this.top_sellers = data.top_sellers;
        this.worst_sellers = data.worst_sellers;
        this.branch_orders = data.branch_orders;

        let tempChartData = {
          labels: [],
          datasets: [
            {
              label: "orders",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(163,142,56,0.5)",
              borderColor: "rgb(163,142,56,1)",
            },
            {
              label: "units",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(192,192,192,0.5)",
              borderColor: "rgb(192,192,192,1)",
            },
          ],
        };

        data.rep_orders.forEach((e) => {
          tempChartData.labels.push(e.rep.name);
          tempChartData.datasets[0].data.push(e.total_orders);
          tempChartData.datasets[1].data.push(e.sum_total_quantity);
        });

        this.chartData = tempChartData;
        this.chartReady = true;

        //daily orders
        let tempChartData2 = {
          labels: [],
          datasets: [
            {
              label: "orders",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(163,142,56,0.5)",
              borderColor: "rgb(163,142,56,1)",
            },
            {
              label: "units",
              data: [],
              borderWidth: 1,
              backgroundColor: "rgb(192,192,192,0.5)",
              borderColor: "rgb(192,192,192,1)",
            },
          ],
        };

        data.daily_orders.forEach((e) => {
          tempChartData2.labels.push(e.created_at.substr(0, 10));
          tempChartData2.datasets[0].data.push(e.total_orders);
          tempChartData2.datasets[1].data.push(e.sum_total_quantity);
        });

        this.chartData2 = tempChartData2;
        this.chartReady2 = true;
      } catch (e) {
        if (this.timer) clearInterval(this.timer);
      }
    },

    async getDailyClockings() {
      try {
        let { data } = await clockingRepo.getDailyClockings();
        this.daily_clockings = data.daily_clockings;
      } catch (e) {
        console.log(e);
      } finally {
        this.fetchingClockings = false;
      }
    },

    async clockIn() {
      this.fetchingClockings = true;
      let lat = null;
      let lng = null;
      let err = null;

      try {
        await this.getLocation().then(
          (location) => {
            lat = location.coords.latitude;
            lng = location.coords.longitude;
          },
          (error) => {
            err = "Browser Error: " + error.message;
          }
        );

        await clockingRepo.create({
          direction: "In",
          latitude: lat,
          longitude: lng,
          error: err,
        });

        this.getDailyClockings();
      } catch (e) {
        if (e.response && e.response.status == 400) {
          this.$root.$bvToast.toast("Request an admin to setup your profile", {
            title: "Error",
            autoHideDelay: 1500,
            variant: "danger",
          });
        }
      } finally {
        this.fetchingClockings = false;
      }
    },
    async clockOut() {
      this.fetchingClockings = true;
      let lat = null;
      let lng = null;
      let err = null;

      try {
        await this.getLocation().then(
          (location) => {
            lat = location.coords.latitude;
            lng = location.coords.longitude;
          },
          (error) => {
            err = "Browser Error: " + error.message;
          }
        );

        await clockingRepo.create({
          direction: "Out",
          latitude: lat,
          longitude: lng,
          error: err,
        });

        this.getDailyClockings();
      } catch (e) {
        if (e.response && e.response.status == 400) {
          this.$root.$bvToast.toast("Request an admin to setup your profile", {
            title: "Error",
            autoHideDelay: 1500,
            variant: "danger",
          });
        }
      } finally {
        this.fetchingClockings = false;
      }
    },

    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          this.$router.push({ path: "no-location" });
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          },
          {
            timeout: 10 * 1000,
          }
        );
      });
    },
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companies() {
      return this.$store.state.user.companies;
    },
    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
    cc() {
      return this.companies.filter((c) => c.id == this.current_company_id)[0];
    },
  },
};
</script>

<style>
.circle-icon-con {
  height: 70px;
  width: 70px;
  border-radius: 35px;
  padding-top: 5px;
  color: white;
}
.circle-icon {
  height: 60px;
  width: 60px;
  border-radius: 30px;
  margin: auto;
  line-height: 60px;
  text-align: center;
  border: solid 5px white;
}
</style>
